import { CubeIcon } from '@heroicons/react/24/outline';
import { Editor, EditorContent } from '@tiptap/react';
import { useState } from 'react';

import { Icon } from '@/components/core/Icon';
import { useTranslation } from '@/hooks/useTranslation';
import { relativeUrlResolver } from '@/services/utils';

import { defaultBlocks, UIBlock } from './default-ui-blocks';
import { EditorBubbleMenu } from './EditorBubbleMenu';
import { EditorToolbar, EditorWidth } from './EditorToolbar';

const EditorTab = ({ editor, showBlocks }: { editor: Editor | null, showBlocks:boolean }) => {

    const { t } = useTranslation();
    const [editorWidth, setEditorWidth] = useState<EditorWidth>(EditorWidth.Screen);

    const onDragStart = (event: React.DragEvent<HTMLDivElement>, block: UIBlock) => {
        event?.dataTransfer?.setData('text/html', block.script);
    };

    return (
        <div className="tw-h-full tw-flex tw-flex-row">
            <div className="tw-h-full tw-flex-1 tw-flex tw-flex-col tw-items-center tw-relative">
                <EditorToolbar editorWidth={editorWidth} setEditorWidth={setEditorWidth} />

                <EditorBubbleMenu editor={editor} />

                <EditorContent
                    className={`tw-flex-1 tw-px-2 tw-border tw-border-dashed tw-border-gray-200 tw-border-t-0 tw-overflow-y-auto tw-transition-all
                        ${editorWidth === 'screen' ? 'tw-w-full' : 'tw-w-1/2'}`}
                    editor={editor}
                />
            </div>

            {showBlocks && <div className="tw-flex tw-flex-col tw-relative tw-border tw-border-dashed tw-border-gray-200 tw-border-t-0 tw-border-r-0 tw-bg-gray-100 sm:tw-w-[20%]">
                <div className="tw-flex tw-items-center tw-p-2 tw-z-20 tw-shadow tw-h-12">
                    <Icon icon={CubeIcon} size="lg" variant="dark" />
                    <label className="tw-text-xl tw-bold tw-m-0 tw-ml-2 tw-text-t-sm">{t('ENHANCED_CONTENT.BLOCKS')}</label>
                </div>
                <div className="tw-overflow-y-auto">
                    {defaultBlocks.map(block =>
                        <div
                            key={block.name}
                            className="tw-p-2 tw-my-1 tw-drop-shadow"
                            draggable={true}
                            onDragStart={event => onDragStart(event, block)}
                        >
                            <img className="tw-w-full tw-cursor-grab" alt={block.name} title={block.name} src={relativeUrlResolver(block.imageUrl)} />
                        </div>
                    )}
                </div>
            </div>}
        </div>
    );
};

export { EditorTab };
